module.exports = __webpack_public_path__ + "img/sthlmgaming.be223668.svg";